import { inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockVideos = document.querySelectorAll('.block-video');

    blockVideos.forEach((blockVideo) => {
        inView(blockVideo, () => {
            const video      = blockVideo.querySelector('.block-video__video');
            const poster     = blockVideo.querySelector('.block-video__poster');
            const playButton = blockVideo.querySelector('.block-video__play');

            if (video) {
                video.classList.remove('hidden');
                video.play(); // Ensure video starts playing

                if (poster) poster.classList.add('hidden');
                if (playButton) playButton.classList.add('hidden');
            }
        }, {
            amount: 0.75, // Adjust as needed (75% visible)
            once: true   // Only play once
        });
    });
});
